var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsHiddenDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6925 4.30754C11.1025 4.71759 11.1025 5.38241 10.6925 5.79246C10.2824 6.20251 9.61759 6.20251 9.20754 5.79246L5.95 2.53492L2.69246 5.79246C2.28241 6.20251 1.61759 6.20251 1.20754 5.79246C0.797487 5.38241 0.797487 4.71759 1.20754 4.30754L5.20754 0.307538C5.61759 -0.102513 6.28241 -0.102513 6.69246 0.307538L10.6925 4.30754Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsHiddenDetail);
export default __webpack_public_path__ + "static/media/news_hidden_detail.2ed024188d000561afd9442e8cc44bcd.svg";
export { ForwardRef as ReactComponent };